import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { fetchkampeerplaatsen } from "../../Reducers/actions";
import moment from "moment";
import { Sparklines, SparklinesLine, SparklinesSpots } from "react-sparklines";
import { getsensorstatus } from "../../../Sensors/Reducers/actions";
import { addgastengebruikmeter, finishedboeking } from "../../../GastenVerbruik/Reducers/actions";
import Instellenmeter from "./instellenmeter";
import FilterBar from "./Add-ons/filters";

function FavSesnorenWidget({ kampeerplaatsen, fetchkampeerplaatsen, getsensorstatus, addgastengebruikmeter, finishedboeking }) {
  const [load, setLoad] = useState(true);
  const [search, setSearch] = useState();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(12);
  const [showModal, setShowModal] = useState(true);
  const topRef = useRef(null);
  useEffect(() => {
    // Eerste keer laden
    setLoad(true);
    fetchkampeerplaatsen(size, search, page).then(() => setLoad(false));

    // Interval om elke 30 seconden opnieuw op te halen
    const interval = setInterval(() => {
      fetchkampeerplaatsen(size, search, page);
    }, 30000); // 30.000 ms = 30 seconden

    // Opruimen bij unmount
    return () => clearInterval(interval);
  }, [page, search, size]);
  function isalert(sensor) {
    if (sensor.active == false) return "card-header switchoff";
    if (sensor.status == "false") return "card-header alerttemp";
    else return "card-header";
  }
  function luodate(momn) {
    if (momn.data && momn.data[0]) return moment(momn.data[0].datum).fromNow();
  }
  function graph(row) {
    const data = [];
    if (row.data.length > 0) {
      row.data.map(function (a, key) {
        if (key > 0) {
          data.push(Number(row.data[key - 1].value - Number(a.value)));
        }
        return a;
      });
    }
    return (
      <Sparklines height={80} data={data.reverse()}>
        <SparklinesLine color="#848c45" limit={20} />
        <SparklinesSpots />
      </Sparklines>
    );
  }
  function lastvalue(row) {
    if (row.data.length > 0) {
      return Number(row.data[0].value).toFixed(2);
    } else {
      return null;
    }
  }

  const handleSubmit = (vals, dispatch, props) => {
    setShowModal({ text: "We zijn de meter aan het instellen" });

    addgastengebruikmeter(vals).then((data) => {
      if (data.type === "ADD_GASTEN_VERBRUIK") {
        fetchkampeerplaatsen(size, search, page).then(() => {
          setShowModal(false);
          props.reset(); // Reset het formulier
        });
      } else {
        alert("Er is een fout opgetreden bij het instellen van de meter");
      }
    });
  };

  const boekingafronden = (id, vals) => {
    setShowModal({ text: "We zijn de boeking aan het afronden" });
    finishedboeking(id, vals).then((data) => {
      if (data.type === "ADD_GASTEN_VERBRUIK") {
        fetchkampeerplaatsen().then((data) => {
          setShowModal(false);
        });
      } else {
        alert("Er is een fout opgetreden bij het afronden van de boeking");
      }
    });
  };

  const reloadplaatsen = () => {
    fetchkampeerplaatsen(size, search, page).then(() => {
      setLoad(false);
    });
  };
  const handleSearchChange = (e) => {
    if (e.target.value.length > 1 || e.target.value.length === 0) {
      setSearch(e.target.value);
      fetchkampeerplaatsen(size, e.target.value).then(() => {
        setLoad(false);
        setPage(0); // Reset de pagina naar 0
      });
    } else {
      setSearch(e.target.value);
      setPage(0); // Reset de pagina naar 0
    }
  };

  const scrollToTop = () => {
    topRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handlePrev = () => {
    setPage((prev) => {
      const newPage = Math.max(prev - 1, 0);
      setTimeout(scrollToTop, 0); // na update scrollen
      return newPage;
    });
  };

  const handleNext = () => {
    setPage((prev) => {
      const newPage = prev + 1;
      setTimeout(scrollToTop, 0); // na update scrollen
      return newPage;
    });
  };

  const filterselectie = (values) => {
    // setLoad(true);
    // fetchkampeerplaatsen(size, search, page, values).then(() => {
    //   setLoad(false);
    //   setPage(0); // Reset de pagina naar 0
    // });
  };
  return (
    <div className="row" ref={topRef}>
      <div className="col-size mb-3">
        <label htmlFor="search-bar-0" className="search-label">
 
          <input id="search-bar-0" onChange={handleSearchChange} type="text" aria-labelledby="search-bar-0-label" className="form-control" placeholder="Zoeken" value={search} />
        </label>
      </div>
      {load ? (
        <div className="col-lg-size">
          <div className="alert alert-info">Laden...</div>
        </div>
      ) : (
        kampeerplaatsen.length > 0 &&
        kampeerplaatsen.map((sensor, key) => (
          <div key={key} className="col-lg-4 p-4">
            <div className="tempsensor card card-primary">
              <div className={isalert(sensor)}>
                <h3 className="card-title">{sensor.naam}</h3>
              </div>
              {graph(sensor)}
              <hr />{" "}
              <div className="details d-flex">
                {/* Relais status */}

                {sensor?.sensor?.electra?.status === "processing" ? (
                  <div className="text-center mx-3">
                    <div className="spinner-border" role="status" style={{ width: "40px", height: "40px" }}>
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div className="text-center mx-3">
                    <img src={sensor?.sensor?.electra?.ingeschakeld ? "/img/plug_ok.png" : "/img/plug_error.png"} width={40} height={40} alt="Relais status" />
                    <div className="small-text">{sensor?.sensor?.electra?.ingeschakeld ? "Ingeschakeld" : "Uitgeschakeld"}</div>
                  </div>
                )}
                {/* Boeking status */}
                {sensor?.sensor?.boeking?.gastinfo && (
                  <div className="text-center mx-3">
                    <img src="/img/booking.png" width={40} height={40} alt="Boeking aanwezig" />
                    <div className="small-text">Boeking</div>
                  </div>
                )}

                {/* Tegoed van de boeking */}
                {sensor?.sensor?.boeking?.tegoed && (
                  <div className="text-center mx-3">
                    <img src="/img/kwh.png" width={40} height={40} alt="Tegoed" />
                    <div className="small-text">{sensor?.sensor?.boeking?.tegoed} kWh</div>
                  </div>
                )}

                {sensor?.sensor?.boeking?.gastinfo && (
                  <div className="text-center mx-3">
                    {sensor?.sensor?.boeking?.gastinfo?.achternaam ? (
                      <>
                        <img src="/img/user.png" width={40} height={40} alt="Boeker" />
                        <div className="small-text">{`${sensor?.sensor?.boeking?.gastinfo?.tussennaam || ""} ${sensor?.sensor?.boeking?.gastinfo?.achternaam}`}</div>
                      </>
                    ) : (
                      <>
                        <img src="/img/boot.png" width={40} height={40} alt="Boot" />
                        <div className="small-text">{sensor?.sensor?.boeking?.gastinfo?.bootnaam || "Bootnaam onbekend"}</div>
                      </>
                    )}
                  </div>
                )}
                {sensor?.sensor?.kwh > 0 && (
                  <div className="text-center mx-3">
                    <span className="kwhtegoed">{Number(sensor?.sensor.uitschakelwaarde - sensor?.sensor?.lastvalue).toFixed(2)}</span> kWh
                    <div className="small-text">Tegoed</div>
                  </div>
                )}
                {sensor?.sensor?.boeking && !sensor?.sensor?.boeking?.betaald && (
                  <div className="text-center mx-3">
                    <img src="/img/erorpaid.png" width={50} height={40} alt="Boeker" />
                    <div className="small-text">Niet betaald</div>
                  </div>
                )}
              </div>
              <hr />
              <div className="details">
                {sensor.active ? <div className="valuekwh">{lastvalue(sensor)}</div> : <div className="valueswitchoff">Uitgeschakeld</div>}

                <div className="meeting">Meting {luodate(sensor)}</div>
                {sensor?.sensor?.boeking?.ampere && <span className="badge-ampere warning">{sensor.sensor.boeking.ampere} A</span>}
              </div>
              <div className="card-footer">
                <Instellenmeter boekingafronden={boekingafronden} showModal={showModal} sensor={sensor} onSubmit={handleSubmit} reloadplaatsen={reloadplaatsen} plaatsen={kampeerplaatsen} />
              </div>
            </div>
          </div>
        ))
      )}
      <nav className="d-flex justify-content-center mt-4">
        <ul className="pagination">
          <li className={`page-item ${page === 0 ? "disabled" : ""}`}>
            <button className="page-link" onClick={handlePrev}>
              ← Vorige
            </button>
          </li>
          <li className="page-item disabled">
            <span className="page-link">Pagina {page + 1}</span>
          </li>
          <li className={`page-item ${kampeerplaatsen.length < size ? "disabled" : ""}`}>
            <button className="page-link" onClick={handleNext} disabled={kampeerplaatsen.length < size}>
              Volgende →
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}
function mapStateToProps(state) {
  return { user: state.auth.user, kampeerplaatsen: state.standplaatsen.kampeerplaatsen };
}
export default connect(mapStateToProps, { fetchkampeerplaatsen, getsensorstatus, addgastengebruikmeter, finishedboeking })(FavSesnorenWidget);
